
import './App.css';
import Header from './components/Header';
import Second from './components/Second';
import Third from './components/Third';
import Fourth from './components/Fourth';
import Commitment from './components/Commitment';
import Visionmission from './components/Visionmission';
import Ourstr from './components/Ourstr';
import Latest from './components/Latest';
import View from './components/View';

function App() {
  return (

    <div className="App">
      <Header></Header>
      <Second></Second>
      <Third></Third>
      <Fourth></Fourth>
      <Commitment></Commitment>
      <Visionmission></Visionmission>
      <Ourstr></Ourstr>
      <Latest></Latest>
      <View></View>
       </div>
  );
}

export default App;
